// extracted by mini-css-extract-plugin
export default {"component":"TrustpilotReviewsCarousel__component-GtlP","largeTitle":"TrustpilotReviewsCarousel__largeTitle-uX79","mw-i":"TrustpilotReviewsCarousel__mw-i-aeq4"};